import { AHText, AHTextFonts, AHTextProps, Box, BoxProps } from "arkh";
import React from "react";
import { StyleProp, ViewStyle } from "react-native";

export const ListSectionHeader = ({
  children,
  style,
  color,
}: React.PropsWithChildren<{
  style?: StyleProp<ViewStyle>;
  color?: BoxProps["color"];
}>) => {
  return (
    <Box
      color={color}
      spaceHorizontal="small"
      spaceBottom="small"
      style={[{ flexDirection: "row", alignItems: "center" }, style]}
    >
      {children}
    </Box>
  );
};

export const ListSectionHeaderTitle = (props: Exclude<AHTextProps, "type">) => {
  return <AHText {...props} type="title-small" />;
};

export const ListSectionHeaderDescription = (
  props: Exclude<AHTextProps, "type">
) => {
  return (
    <AHText
      spaceTop="xsmall"
      type="subtitle"
      font={AHTextFonts.REGULAR}
      color="darkText"
      style={{ maxWidth: 500, lineHeight: 16 }}
    >
      {props.children}
    </AHText>
  );
};
